// extracted by mini-css-extract-plugin
export default {"root":"EditUserGroupModal_root__fiPYE","container":"EditUserGroupModal_container__wNrGS"};